import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask"; 
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { StyledForm } from "../../styled-components/StyledForm.style";

// Recebemos 'registroEdicao' (o ID) que é o objeto clicado na listagem pai
export const ModalCalendarioIndisponibilidadesOcorrencias = ({ isOpen, setIsOpen, registroEdicao, onRequestClose }) => {
    const [isLoading, setisLoading] = useState(false);
    const [dados, setDados] = useState(null);
    
    const style = {
        content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)',
            borderRadius: "0px", minWidth: '50%', overflowY: 'auto', 
            minHeight: '50%', maxHeight: '90%'
        },
        overlay: { zIndex: 9999 }
    };

    const closeModal = () => {
        setisLoading(false);
        setIsOpen(false);
    };

    const carregarRegistro = async (id) => {
        setisLoading(true);
        try {
            const response = await api.get(`WipFeriasAusencias/list/ocorrencias/${id}`);
            const data = response.data.data;
            setDados(data);
        } catch (error) {
            console.error("Erro ao carregar registro:", error);
            Swal.fire('Erro', 'Não foi possível carregar os dados.', 'error');
            closeModal();
        } finally {
            setisLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen && registroEdicao) {
            carregarRegistro(registroEdicao);
        }
    }, [isOpen, registroEdicao]);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Editar Indisponibilidade"
            style={style}
            ariaHideApp={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <i className="fa fa-comments-o pe-2" style={{ fontSize: '24px', color: '#EE4B21' }}></i>
                                    Ocorrências Férias / Ausências
                                </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button type="button" className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                
                { isLoading ? (
                    <div className="text-center py-4">
                        <div className="spinner-border" style={{ color: "#EE4B21" }} role="status"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Carregando dados...</strong>
                        </div>
                    </div>
                ) : (
                    <div style={{ padding: '0 10px 20px 10px' }}>
                        
                        {/* LISTA DE OCORRENCIAS */}
                        { dados?.map((item) => (
                            <React.Fragment key={item.idFeriasAusencia}>
                                <div className="card mb-2">
                                    <div className="card-body pt-1 pb-0 px-2 row mb-2" style={{ fontSize: "14px" }}>
                                        <div className="position-absolute top-0 end-0 badge rounded opacity-50 bg-secondary " style={{ color: "#fff", fontSize: "12px", fontWeight: "normal", width: "340px" }}><i className="fa fa-user"></i> {item.nomeProfissionalOcorrencia} <i className="fa fa-square ms-2"></i> {item.tipoAcaoDescricao} <i className="fa fa-calendar ms-2"></i> { new Date(item.dataOcorrencia).toLocaleDateString('pt-BR') }</div>
                                        <div className=""><strong>{item.nomeProfissional}</strong> - {item.tipoDescricao}</div>
                                        <div className="">{item?.justificativaOcorrencia || <>&nbsp;</>}</div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )) }

                        { dados?.length === 0 && (
                            <div className="text-center mt-4 mb-4">
                                <span style={{ color: "#999" }}>Nenhuma mensagem encontrada para essa ocorrência.</span>
                            </div>
                        ) }
                    </div>
                )}
            </StyledForm>
        </Modal>
    );
};